import { ChartData } from '../data/ChartData';
import { ChartDataArray } from '../data/ChartDataArray';
import { ChartDataType } from '../data/ChartDataType';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { ColumnBarRenderer } from './ColumnBarRenderer';

export class BarRenderer extends ColumnBarRenderer {
  constructor(
    gElement: d3.Selection<SVGGElement, unknown, null, undefined>,
    private data: ChartDataArray,
    hasComparison: boolean,
    private hasSecondaryData: boolean,
    public secondaryAxis?: boolean
  ) {
    super(gElement, data, hasComparison);
  }

  public render(x: d3.ScaleLinear<number, number>, y: d3.ScaleBand<string>, limit?: number) {
    const basePadding: number =
      BarRenderer.PADDING +
      (this.hasComparison ? BarRenderer.COMPARISON_EXTRA : 0) +
      (this.hasSecondaryData ? BarRenderer.SECONDARY_EXTRA : 0);

    const barSpace: number = y.bandwidth() - basePadding;

    const barHeight: number =
      Math.min(BarRenderer.MAX_BAR_WIDTH, barSpace / (this.hasSecondaryData ? 2 : 1)) +
      (this.data.isComparison ? BarRenderer.COMPARISON_EXTRA : 0);

    const yAdjustment =
      y.bandwidth() / 2 +
      (!this.data.isSecondary
        ? !this.hasSecondaryData
          ? -barHeight / 2
          : -barHeight - BarRenderer.SECONDARY_EXTRA / 2
        : BarRenderer.SECONDARY_EXTRA / 2);

    const zeroX = x(0);
    // primary and not comparison case

    const handlers: ColumnBarChartAttrHandler = {
      x: (d: ChartData): number => Math.min(x(d.value!), zeroX),
      y: (d: ChartData): number => y(d.label!)! + yAdjustment,
      height: (): number => barHeight,
      width: (d: ChartData): number => Math.abs(zeroX - x(d.value!)),
      class: (d: ChartData): string => [this.className || '', d.color || ''].join(' '),
    };

    if (ChartDataType.primary === this.data.type && this.data.isPlan) {
      handlers.x = (d: ChartData) => x(d.value!) - 1;
      handlers.y = (d: ChartData) => y(d.label!)!;
      handlers.width = () => 2;
      handlers.height = () => y.bandwidth();
      if (this.hasSecondaryData) {
        handlers.height = () => y.bandwidth() / 2;
      }
    } else if (ChartDataType.secondary === this.data.type && this.data.isPlan) {
      handlers.x = (d: ChartData) => x(d.value!)! - 1;
      handlers.y = (d: ChartData) => y(d.label!)! + y.bandwidth() / 2;
      handlers.width = () => 2;
      handlers.height = () => y.bandwidth() / 2;
    }

    super.renderInternal(this.data, handlers, limit, true);
  }

  public switchHighlight(_index: number, _highlight: boolean) {}
}
